"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderOverlay = void 0;
exports.RenderHeaderOverlay = RenderHeaderOverlay;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const context_1 = require("../../context");
const HeaderOverlay = () => {
    const { activePopup, setActivePopup } = React.useContext(context_1.HeaderContext);
    const hiddeSearchComponent = () => {
        setActivePopup(null);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: activePopup !== null && ((0, jsx_runtime_1.jsx)("div", { className: "bg-overlay-primary fixed z-[7] inset-0 h-full w-full hidden md:block", onClick: hiddeSearchComponent })) }));
};
exports.HeaderOverlay = HeaderOverlay;
function RenderHeaderOverlay(element) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(exports.HeaderOverlay, {}), element);
}
